import React from 'react';
import { Link } from 'react-router-dom';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddFormChoiceButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="contained"
    component={Link}
    to={`/form_choices/create?form_item=${record['@id']}`}
    label="Add a form choice"
    title="Add a form choice"
  >
    <AddBoxIcon />
  </Button>
);

export default withStyles(styles)(AddFormChoiceButton);
